import { useQuery } from '@tanstack/react-query';
import useApiStore from '../../store/useApiStore';
import { IStates } from '../../types';
import { STATES_KEY } from '../../utils/constants';
import Api from '../Api';

interface RESPONSE {
  [key: string]: string;
}

const transformer = (statesObj: { [key: string]: string }): IStates[] =>
  Object.keys(statesObj).map((state) => ({ code: state, name: statesObj[state] }));

export default function useGetStates() {
  const { onError } = useApiStore();

  return useQuery<IStates[], Error>({
    queryKey: [STATES_KEY],
    queryFn: async () => {
      const api = new Api({ onError });

      const data: RESPONSE = await api.get({
        url: 'api/v1/locations/states/names',
      });

      return transformer(data);
    },
  });
}
